<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
                 
            <vs-input class="inputx" placeholder="Paket Stok Kodu" @keyup.enter="stokListesi()"  :ref="barkod" v-model="barkod" />
            <vs-input class="inputx" placeholder="Mikro Stok Kodu"  :ref="barkod1" v-model="barkod1" />
            <vs-input class="inputx" placeholder="Fiyat" @keyup.enter="stokListesiEkle()"  :ref="fiyat" v-model="fiyat" />
                    </div>
      </vx-card>
      <br/>

    </div>
<div class="vx-col w-full mb-base">
    <vs-table :data="liste" >

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Paket Stok Kodu</vs-th>
      <vs-th  sort-key="stokkodu">Mikro Stok Kodu</vs-th>
      <vs-th>Fiyat</vs-th>
      <vs-th></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
 <vs-td :data="data[indextr].orderNumber">
          {{ data[indextr].stokKodu }}
        </vs-td>
        <vs-td :data="data[indextr].orderNumber">
          {{ data[indextr].eslesenStokKodu }}
        </vs-td>
        <vs-td :data="data[indextr].partiNo">
          {{ data[indextr].fiyat }}
        </vs-td>
      
       
     
        <vs-td>
        <vs-button @click="sil(data[indextr].id)" color="success" type="filled">Sil</vs-button>
        </vs-td>
      </vs-tr>
     
     
    </template>

  </vs-table>
</div>



  </div>





        



    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
      liste:[],
      kod:'',
      barkod:'',
      barkod1:'',
      fiyat:'',
    }
  },methods: {
    stokListesi(){
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)
      
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,stokKodu:this.barkod}
      soap.createClient(url, function(err, client){
      client.paketEslestirmeListesi(args, function(err, result){
        if (result.paketEslestirmeListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        //console.log(result.stokResimListesiResult)
        vm.veriler=JSON.parse(result.paketEslestirmeListesiResult)
        vm.liste=vm.veriler
       // vm.eslesenStokListesi=vm.veriler
        
  
      
       
        
      })
      })

    },
    stokListesiEkle(){
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)
      
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,stokKodu:this.barkod,eslesenStokKodu:this.barkod1,fiyat:this.fiyat}
      soap.createClient(url, function(err, client){
      client.paketEslestir(args, function(err, result){
        if (result.paketEslestirResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        //console.log(result.stokResimListesiResult)
        vm.veriler=JSON.parse(result.paketEslestirResult)
        if (vm.veriler.response=="Ok") {
            vm.stokListesi()
        }
        
       // vm.eslesenStokListesi=vm.veriler
        
  
      
       
        
      })
      })

    },
    sil(id){
      //alert(this.resimAdi+this.dStokKodu+this.dBarkod)
      
         var vm = this

    const soap = require('soap')
      const url = state.sistemAddress
     
      const args = {token:Store.state.tokenId,id:id}
      soap.createClient(url, function(err, client){
      client.paketEslestirSil(args, function(err, result){
        if (result.paketEslestirSilResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
        //console.log(result.stokResimListesiResult)
        vm.veriler=JSON.parse(result.paketEslestirSilResult)
        if (vm.veriler.response=="Ok") {
            vm.stokListesi()
        }
        
       // vm.eslesenStokListesi=vm.veriler
        
  
      
       
        
      })
      })

    }
  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        
      },
      deep: true
    }
  },beforeMount(){
    
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
